<template>
  <div>
    <!-- Filter Button -->
    <div class="text-right">
      <p
        @click="openMenu"
        class="f-18 mb-0 fw-500 text-align-right mt-20"
      >
        Show Filters
        <img src="@/assets/icons/filter_black.svg" alt="filters" />
      </p>
    </div>

    <!-- Mobile Modal -->
     
    <transition name="slide-up">
      <div v-if="isOpen" class="mobile-menu-modal">
        <!-- Header -->
        <div class="mobile-menu-header">
          <div class="mobile-close" @click="closeMenu">✕</div>
        </div>

        <!-- Back Button -->
        <div
          v-if="currentLevelIndex > 0"
          class="mobile-back pl-4"
          @click="goBack"
        >
          <span class="mobile-menu-icon">
            <i class="fa fa-angle-left"></i>
          </span>
          <span class="fw-700 ml-15">
            {{ parentTitle }}
          </span>
        </div>
        <div    v-if="currentLevelIndex > 0" class="mobile-back-divider"></div>

        <!-- Category Levels -->
        <transition
          :name="slideDirection === 'forward' ? 'slide-forward' : 'slide-back'"
          mode="out-in"
        >
          <ul
            :key="currentLevelIndex"
            class="mobile-level"
          >
            <li
              v-for="item in currentLevelItems"
              :key="item._id"
              class="mobile-item"
              @click="handleItemClick(item)"
            >
              <span >
                {{ item.displayName || item.name }}
              </span>

              <span
                v-if="item.children && item.children.length"
                class="tixstock-mobile-arrow"
              >
                <span class="mobile-menu-icon">
                  <i class="fa fa-angle-right"></i>
                </span>
              </span>
            </li>
          </ul>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "TixstockMobileMenu",

  data() {
    return {
      isOpen: false,
      activeStack: [],
      currentLevelIndex: 0,
      slideDirection: "forward"
    };
  },

  computed: {
    ...mapGetters({
      menu: "tixstockNavcategories"
    }),

    currentLevelItems() {
      if (this.currentLevelIndex === 0) {
        return this.menu || [];
      }
      const parent = this.activeStack[this.currentLevelIndex - 1];
      return parent && parent.children ? parent.children : [];
    },

    parentTitle() {
      const parent = this.activeStack[this.currentLevelIndex - 1];
      return parent ? parent.displayName || parent.name : "";
    }
  },

  methods: {
    handleItemClick(item) {
      if (item.children && item.children.length) {
        this.goNextLevel(item);
      } else {
        this.goToCategory(item);
      }
    },
    openMenu() {
      this.isOpen = true;
      this.activeStack = [];
      this.currentLevelIndex = 0;
      this.slideDirection = "forward";
    },

    closeMenu() {
      this.isOpen = false;
      this.activeStack = [];
      this.currentLevelIndex = 0;
    },

    goNextLevel(item) {
      if (!item.children || !item.children.length) return;
      this.slideDirection = "forward";
      this.activeStack.push(item);
      this.currentLevelIndex++;
    },

    goBack() {
      this.slideDirection = "back";
      this.activeStack.pop();
      this.currentLevelIndex--;
    },

    goToCategory(item) {
      if (!item.slug) return;
      this.closeMenu();
      this.$router.push(`/international/event/${item._id}`);
    }
  }
};
</script>

<style scoped>
/* Modal Container */
.mobile-drawer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.45);
  z-index: 1049;
}
.mobile-menu-modal {
  position: fixed;
  inset: 0;
  background: #fff;
  z-index: 10000;
  padding: 16px;
  overflow-y: auto;
}

/* Header */
.mobile-menu-header {
  padding: 20px 0;
  position: relative;
}

.mobile-close {
 font-size: 20px;
    cursor: pointer;
    text-align: right;
    padding-right: 5px;
}

/* Back */
 .mobile-back {
   display: flex;
   align-items: center;
   font-size: 18px;
   font-weight: 600;
   margin-bottom: 12px;
   cursor: pointer;
   text-transform: capitalize;
   padding: 16px;
   font-size: 22px;
   border-bottom: none;
   margin: 0px !important;
 }

 .mobile-back .mobile-menu-icon {
   display: flex;
   align-items: center;
   line-height: 1;
 }

 .mobile-back .mobile-menu-icon i {
   line-height: 1;
 }

 .mobile-back .fw-700 {
   line-height: 1;
 }

 .mobile-back-divider {
   border-bottom: 1px solid #c9c9c9;
   margin: 0 15px 12px;
 }
/* List */
.mobile-level {
  list-style: none;
  padding: 0;
  margin: 0;
  min-height: 400px;
}

.mobile-item {
  display: flex;
  justify-content: space-between;
  padding: 10px 4px;
  font-size: 16px;
  color: #677383;
  text-align: left;
  line-height: 1.3;
}

.tixstock-mobile-arrow {
  width: 40px;
  text-align: right;
  font-size: 20px;
  cursor: pointer;
}

.mobile-menu-icon {
  color: #677383;
}

/* ================= Modal Slide ================= */
.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.35s ease, opacity 0.35s ease;
}

.slide-up-enter-from {
  transform: translateY(100%);
  opacity: 0;
}

.slide-up-leave-to {
  transform: translateY(100%);
  opacity: 0;
}

/* ============ Forward (Parent → Child) ============ */
.slide-forward-enter-active,
.slide-forward-leave-active {
  transition: transform 0.35s ease, opacity 0.25s ease;
}

.slide-forward-enter-from {
  transform: translateX(100%);
  opacity: 0;
}

.slide-forward-leave-to {
  transform: translateX(-30%);
  opacity: 0;
}

/* ============ Back (Child → Parent) ============ */
.slide-back-enter-active,
.slide-back-leave-active {
  transition: transform 0.35s ease, opacity 0.25s ease;
}

.slide-back-enter-from {
  transform: translateX(-100%);
  opacity: 0;
}

.slide-back-leave-to {
  transform: translateX(30%);
  opacity: 0;
}
</style>
